var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 1.33333V2.66667C11.403 2.66667 12 3.26362 12 4V7.66667C12 7.85076 11.8508 8 11.6667 8H10.6667V10.6667C10.6667 11.403 10.0697 12 9.33333 12H2.66667C1.93029 12 1.33333 11.403 1.33333 10.6667V8H0.333333C0.149238 8 0 7.85076 0 7.66667V4C0 3.26362 0.596954 2.66667 1.33333 2.66667V1.33333C1.33333 0.596954 1.93029 0 2.66667 0H9.33333C10.0697 0 10.6667 0.596954 10.6667 1.33333ZM9.33333 1.33333H2.66667V2.66667H9.33333V1.33333ZM9.33333 10.6667H2.66667V6.66667H9.33333V10.6667ZM10.3333 5.33333C10.5174 5.33333 10.6667 5.18409 10.6667 5V4.33333C10.6667 4.14924 10.5174 4 10.3333 4H9.66667C9.48257 4 9.33333 4.14924 9.33333 4.33333V5C9.33333 5.18409 9.48257 5.33333 9.66667 5.33333H10.3333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintOut);
export default __webpack_public_path__ + "static/media/print-out.599fdff120eb98ca7975da55b8a0d563.svg";
export { ForwardRef as ReactComponent };